import { Link } from "react-router-dom";
import PageBanner from "@/components/feature/PageBanner";

const whyShopWithUs = [
  {
    icon: "ri-t-shirt-line",
    title: "Pure Cotton, Pure Comfort",
    description:
      "Every piece is crafted from breathable, skin-friendly cotton sourced with care.",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Honest Pricing",
    description:
      "Premium ethnic wear at fair, transparent prices — no hidden costs, no markups.",
  },
  {
    icon: "ri-heart-line",
    title: "Made with Love in Meerut",
    description:
      "Designed and stitched locally with attention to every seam and detail.",
  },
];

export default function About() {
  return (
    <div>
      <PageBanner
        title="Our Story"
        subtitle="Thoughtfully made cotton ethnic wear for the everyday woman."
        bgImage="/images/about-banner.jpg"
      />

      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <div className="space-y-5 text-foreground-700 text-sm md:text-base leading-relaxed mb-10">
              <p>
                NeoRoop was born from a simple belief — that everyday ethnic
                wear should feel as good as it looks. We are a boutique label
                creating thoughtfully made cotton kurtas and sets for women who
                want elegance without effort. No heavy embellishments, no
                uncomfortable fabrics — just soft, breathable pieces designed to
                move with you through your day, whether you are at work, at
                home, or out with friends.
              </p>
              <p>
                Every NeoRoop piece is crafted with a quality-first approach.
                From the cotton we source to the stitches that hold each garment
                together, we pay attention to the details that matter. Our
                designs draw from the rich textile traditions of India while
                keeping silhouettes modern and wearable. Based in Meerut, Uttar
                Pradesh, we work closely with skilled local artisans who bring
                each piece to life — because we believe good craftsmanship
                should never be rushed.
              </p>
            </div>

            <div className="mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-accent-800 mb-6 text-center">
                Why shop with us
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                {whyShopWithUs.map((item, index) => (
                  <div
                    key={index}
                    className="group bg-background-100 rounded-2xl p-6 md:p-8 shadow-sm border border-background-200/70 transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4 transition-all duration-300 group-hover:bg-secondary-200 group-hover:scale-105">
                      <i
                        className={`${item.icon} w-5 h-5 flex items-center justify-center text-lg`}
                      />
                    </div>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-accent-800 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="text-center">
              <Link
                to="/shop"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-lg text-base font-semibold hover:bg-secondary-500 transition-colors whitespace-nowrap shadow-sm"
              >
                Shop the Collection
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}